var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-testid": "visit-diagnosis"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('list-diagnosis', {
    attrs: {
      "focus-input": _vm.focusAddActionInput,
      "do-update": _vm.reloadDiagnosis
    },
    on: {
      "focused": _vm.isFocused,
      "updated": _vm.updateDiagnosisDone,
      "disease": _vm.primaryDisease
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-body bg-info"
  }, [_c('add-diagnosis', {
    attrs: {
      "focus-input": _vm.focusAddDiagnosisInput
    },
    on: {
      "update": _vm.updateDiagnosis
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-body bg-secondary"
  }, [_c('add-diagnosis-template', {
    on: {
      "update": _vm.updateDiagnosis
    }
  })], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e0294e4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Visit/components/VisitDiagnosis.vue
// module id = 542
// module chunks = 0